export default function adjustDarkScreenTop () {
  const scrollTop = $(window).scrollTop()
  $('.dark-screen').css('top', scrollTop)
};
